import { jsx as o } from "react/jsx-runtime";
import * as d from "react";
import { cva as p } from "class-variance-authority";
import { cn as g } from "../../../lib/utils.js";
const b = p("inline-flex items-center whitespace-nowrap rounded-full border px-3 py-1 text-xs font-semibold transition-all duration-300 shadow-subtle", {
  variants: {
    variant: {
      default: "border-border-color bg-bg-muted/50 text-text-primary hover:bg-bg-muted",
      secondary: "border-lpr-teal/20 bg-lpr-teal/10 text-lpr-teal hover:bg-lpr-teal/20 dark:border-lpr-aqua/20 dark:bg-lpr-aqua/10 dark:text-lpr-aqua dark:hover:bg-lpr-aqua/20",
      success: "border-lpr-green/20 bg-lpr-green/10 text-lpr-green hover:bg-lpr-green/20",
      warning: "border-lpr-gold/20 bg-lpr-gold/10 text-lpr-gold hover:bg-lpr-gold/20",
      error: "border-lpr-red/20 bg-lpr-red/10 text-lpr-red hover:bg-lpr-red/20",
      info: "border-lpr-teal/20 bg-lpr-teal/10 text-lpr-teal hover:bg-lpr-teal/20 dark:border-lpr-gold/20 dark:bg-lpr-gold/10 dark:text-lpr-gold dark:hover:bg-lpr-gold/20",
      outline: "border-border-color bg-transparent text-text-primary hover:bg-bg-muted"
    },
    size: {
      sm: "px-2 py-0.5 text-[10px]",
      md: "px-3 py-1 text-xs",
      lg: "px-4 py-1.5 text-sm"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
}), n = d.forwardRef(({ className: r, variant: e, size: t, ...l }, a) => o("div", { ref: a, className: g(b({ variant: e, size: t }), r), ...l }));
n.displayName = "Badge";
export {
  n as Badge,
  b as badgeVariants
};
//# sourceMappingURL=Badge.js.map
